import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../components';

import './style.scss';

const SearchPage = () => (
  <Container className="Search">
    <div className="row">
      <div className="col-12 col-lg-8 offset-lg-2">
        <SearchAllContent>
          <div className="Search__header">
            <SearchAllContent.SearchBar />
            <SearchAllContent.Facets />
          </div>

          <div className="Search__results">
            <SearchAllContent.Stats />
            <SearchAllContent.Results />
          </div>

          <div className="Search__pager">
            <SearchAllContent.Pagination />
          </div>
        </SearchAllContent>
      </div>
    </div>
  </Container>
);

export default SearchPage;
